module.exports = __webpack_public_path__ + "img/logo.eb12cf78.png";